import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import {
  LocationStrategy,
  HashLocationStrategy,
  PathLocationStrategy,
} from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
// material
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatTabsModule } from "@angular/material/tabs";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material";

import { AppComponent } from "./app.component";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TabsModule } from "ngx-bootstrap/tabs";
import { NAV_DROPDOWN_DIRECTIVES } from "./shared/nav-dropdown.directive";

import { ChartsModule } from "ng2-charts/ng2-charts";
import { SIDEBAR_TOGGLE_DIRECTIVES } from "./shared/sidebar.directive";
import { AsideToggleDirective } from "./shared/aside.directive";
import { BreadcrumbsComponent } from "./shared/breadcrumb.component";
// Routing Module
import { AppRoutingModule } from "./app.routing";
import { PermissionAttribute } from "./directives/permision-attribute/permission.attribute";
// Layouts
import { FullLayoutComponent } from "./layouts/full-layout.component";
import { SimpleLayoutComponent } from "./layouts/simple-layout.component";
// Services
import { ApiService } from "./services/api";
import {
  AuthGuardService,
  CanDeactivateGuard,
  RouteAuthGuardService,
  AdminRouteAuthGuardService
} from "./services/auth-guard";
import { ElasticService } from "./services/elastic";
import { FormsService } from "./services/forms";
import { OAuthService } from "./services/o-auth";
import { VersionCheckService } from "./services/check-version/version-check.service";
import { PagerService } from "./services/pagination/pager.service";
import { PaymentsService } from "./services/payments/payments.service";
// Config
import { environment } from "./../environments/environment";
// External
import { AngularFireModule } from "angularfire2";
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireDatabase } from "angularfire2/database";
import "firebase/storage";
// import { DatabaseComponent } from './pages/database/database.component';

import { CommonModule } from "@angular/common";
import { NgSelectModule } from "@ng-select/ng-select";
import { AccordionModule } from "primeng/accordion";

import { ClubsComponent } from "./components/clubs-component/clubs.component";
import { ConfirmClubComponent } from "./components/confirm-club-component/confirm.club.component";
import { InsightComponent } from "./components/insight/insight-component/insight.component";
import { ClubDetailComponent } from "./components/club-detail-component/club.detail.component";
import { UsersComponent } from "./components/users-component/users.component";
import { UserDetailComponent } from "./components/user-detail-component/user.detail.component";
import { PostsComponent } from "./components/posts-component/posts.component";

import { PostDetailComponent } from "./components/post-detail-component/post.detail.component";
import { PostEveryoneComponent } from "./components/post-everyone-component/post.everyone.component";
import { CreatePostEveryoneComponent } from "./components/create-post-everyone/create.post.everyone.component";
import { TournamentsComponent } from "./components/tournaments-component/tournaments.component";
import { AddTournamentNewComponent } from "./components/add-tournament-new/add.tournament.component";
import { ScorecardsComponent } from "./components/scorecards-component/scorecards.component";
import { ClubScorecardsComponent } from "./components/club-scorecards-component/club.scorecards.component";
import { CompanyComponent } from "./components/company-component/company.component";
import { CompanyDetailComponent } from "./components/company-detail-component/company.detail.component";
import { TournamentDetailComponent } from "./components/tournament-detail-component/tournament.detail.component";
import { UpdateTournamentComponent } from "./components/update-tournament/update.tournament.component";
import { UpdateOfferComponent } from "./components/update-offer/update.offer.component";
import { ClubSubscriptionsComponent } from "./components/club-subscriptions-component/club.subscriptions.component";
import { ClubSubscriptionDetailComponent } from "./components/club-subscription-detail-component/club.subscription.detail.component";
import { OffersComponent } from "./components/offers-component/offers.component";
import { OrdersComponent } from "./components/orders-component/orders.component";
import { TeeComponent } from "./components/tee-component/tee.component";
import { AddHolesComponent } from "./components/add-holes-component/add.holes.component";
import { OfferDetailComponent } from "./components/offer-detail-component/offer.detail.component";
import { OrderDetailComponent } from "./components/order-detail-component/order.detail.component";
import { CreateOfferComponent } from "./components/create-offer-component/create.offer.component";
import { TermConditionComponent } from "./components/term-condition-component/term.condition.component";
import { PrivatePolicyComponent } from "./components/private-policy-component/private.policy.component";
import { AppVersionComponent } from "./components/app-version-component/app.version.component";
import { BankComponent } from "./components/bank-component/bank.component";
import { AttachmentsComponent } from "./components/attachments-component/attachments.component";
import { ChangePasswordComponent } from "./components/change-password-component/change.password.component";
import { CourseComponent } from "./components/course-component/course.component";
import { EntryNotificationComponent } from "./components/entry-notification-component/entry.notification.component";
import { AddLeagueComponent } from "./components/add-league-component/add.league.component";
import { LeaguesComponent } from "./components/leagues-component/leagues.component";
import { LeagueDetailComponent } from "./components/league-detail-component/league-detail.component";
import { UpdateLeagueComponent } from "./components/update-league-component/update.league.component";
import { TeeTimeBookingComponent } from "./components/tee-time-booking-component/tee-time-booking.component";
import { ClubProfileComponent } from "./components/club-profile-component/profile.component";
import { CompanyProfileComponent } from "./components/company-profile-component/profile.component";
import { FollowersComponent } from "./components/followers-component/followers.component";
import { ClubInsightComponent } from "./components/insight/club-insight-component/insight.component";
import { CompanyInsightComponent } from "./components/insight/company-insight-component/insight.component";
import { ZestMappingComponent } from "./components/zest-course-mapping-component/zest-mapping.component";
import { NotificationComponent } from "./components/notification-component/notification.component";
import { AdvertisementComponent } from "./components/advertisement-component/advertisement.component";
import { PostReportComponent } from "./components/post-report-component/post-report.component";
import { UserReportComponent } from "./components/user-report-component/user-report.component";
import { CommunityDashboardComponent } from "./components/community-dashboard/community-dashboard.component";

import { AgmCoreModule } from "@agm/core";

// Modal Component
import { ModalModule } from "ngx-bootstrap/modal";

// Tabs Component

// Components Routing
import { ComponentsRoutingModule } from "./components/components-routing.module";
// directives
import { PostInfoComponent } from "./directives/post-info";
import { PostComponent } from ".//directives/post";
import { PermissionComponent } from "./directives/permission/permission.component";

import { AttachmentComponent } from "./directives/attachment";
import { AttachmentWithoutCropComponent } from "./directives/attachment-without-crop";
import { AttachmentMultipleComponent } from "./directives/attachment-multiple";
import { TournamentSelectComponent } from "./directives/tournament-select";
import { TextEditorComponent } from "./directives/text-editor";
import { DateTimePickerComponent } from "./directives/date-time-picker";
import { ClubSelectComponent } from "./directives/club-select";
import { UserSelectModalComponent } from "./directives/user-select-modal";
import { TournamentPlayersComponent } from "./directives/tournament-players";

//  pipes
import { OrderModule } from "ngx-order-pipe";
import { HandicapPipe } from "./pipes/handicap/handicap.pipe";
import { MomentPipe } from "./pipes/moment";
import { PostMsgPipe } from "./pipes/post-filter-pipe/post.filter.pipe";
import { TournamentPipe } from "./pipes/tournament-filter-pipe/tournament.filter.pipe";
import { CalendarModule } from "primeng/calendar";
import { DatePipe } from "@angular/common";
import { VerifiedClubPipe } from "./pipes/verified-club-pipe/verfired.club.pipe";
import { UserPipe } from "./pipes/user-pipe/user.pipe";
import { OfferPipe } from "./pipes/offer-filter-pipe/offer.filter.pipe";
import { TeamFilterPipe } from "./pipes/team-filter-pipe/team.filter.pipe";
import { CheckboxModule } from "primeng/checkbox";
import { GeneralPipe } from "./pipes/general-filter-pipe/general.filter.pipe";
import { SafePipe } from "./pipes/safePipe/safe.pipe"
// material
import { NgDragDropModule } from 'ng-drag-drop';
import { MatRadioModule } from "@angular/material/radio";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";

import { MatInputModule } from "@angular/material/input";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatChipsModule } from "@angular/material/chips";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { AmazingTimePickerModule } from "amazing-time-picker"; // this line you need
import { HttpModule } from "@angular/http";

import { MatNativeDateModule } from "@angular/material";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { ImageCropperModule } from "ngx-image-cropper";
import { OrderPipe } from "./pipes/order-filter-pipe/order.filter.pipe";
import { PaymentsListComponent } from "./components/payments-list-component/payments-list.component";
import { NgxEditorModule } from "ngx-editor";
import { PrioritiesComponent } from "./components/priorities-component/priorities.component";
import { SocialDashboardComponent } from "./components/social-dashboard/social-dashboard.component";
import { PlayDashboardComponent } from "./components/play-dashboard/play-dashboard.component";
import { ProshopDashboardComponent } from "./components/proshop-dashboard/proshop-dashboard.component";
import { GeneralDashboardComponent } from "./components/general-dashboard/general-dashboard.component";
import { ClubProfileSubmenuComponent } from "./components/club-profile-submenu-component/club-profile-submenu.component";
import { CompanyProfileSubmenuComponent } from "./components/company-porfile-submenu-component/company-profile-submenu.component";
import { InsightsManagerComponent } from "./components/insights-manager/insights-manager.component";
import { RoleManagerComponent } from "./components/role-manager-component/role-manager-component";
import { BirdietimeIntegrationComponent } from "./components/birdietime-integration-component/birdietime-integration.component";
import { HubberProIntegrationComponent } from "./components/hubber-pro-integration-component/hubber-pro-integration.component";
import { LiveScoringComponent } from "./components/live-scoring-component/live-scoring.component";
import { HubberPracticeComponent } from "./components/hubber-practice-component/hubber-practice.component";
import { SocietyComponent } from "./components/society/society-component/society.component";
import { SocietyProfileSubmenuComponent } from "./components/society/society-profile-submenu-component/society-profile-submenu.component";
import { ClubMembersComponent } from "./components/club-members-component/club.members.component";
import { TourComponent } from "./components/tour/tour-component/tour.component";
import { TourProfileSubmenuComponent } from "./components/tour/tour-profile-submenu-component/tour-profile-submenu.component";
import { FollowerRequestComponent } from "./components/follower-request-component/follower-request.component";
import { PortfolioDashboardComponent } from "./components/portfolio-dashboard/portfolio-dashboard.component";
import { ProfileDashboardComponent } from "./components/profile-dashboard/profile-dashboard.component";
import { MyFollowersComponent } from "./components/my-followers-component/my-followers.component";
import { MyInsightsComponent } from "./components/my-insights-component/my-insights.component";
import { GhMobileAppComponent } from "./components/GH-mobile-app-component/gh-mobile-app-.component";
import { ClubPackageComponent } from "./components/club-package-component/club-package.component";
import { TournamentsMatchplayDetailsComponent } from "./components/tournaments-matchplay-details/tournaments-matchplay-details.component";
import { AdminCompanyInsightsComponent } from "./components/admin-company-insights-component/admin-company.insights.component";
import { EditPostComponent } from "./components/edit-post-component/edit.post.component";
import { TourInsightsComponent } from "./components/tour-insights-component/tour-insights.component";
import { SocietyInsightsComponent } from "./components/society-insights-component/society-insights.component";
import { TotalActiveComponiesComponent } from "./components/total-active-companies/total-active-companies.component";
import { AllPostsComponent } from "./components/all-posts-component/all-posts.component";
import { AppUsersComponent } from "./components/app-users/app-users.component";
import { AppUsersListComponent } from "./components/app-users-list-component/app-users-list.component";
import { EditLeaderboardComponent } from "./components/edit-leaderboard-component/edit-leaderboard.component";
import { EventsComponent } from "./components/events-component/events.component";
import { CreateEventComponent } from "./components/create-event-component/create.event.component";
import * as firebase from "firebase";
import { EventDetailComponent } from "./components/event-details-component/event.detail.component";
import { UpdateEventComponent } from "./components/update-event-details-component/update.event.component";
import { EffectiveTournamentsComponent } from "./components/effective-tournaments-components/effective-tournaments.component";
import { WebsiteEnquiriesComponent } from "./components/website-enquiries/website-enquiries.component";
import { WebsiteTermConditionComponent } from "./components/website-terms-condition-component/website-terms-condition.component";
import { PendingPostsComponent } from "./components/posts-component-pending/posts.component";
import { NgxSummernoteModule } from "ngx-summernote";
import { TextEditorComponentComment } from "./directives/text-editor-comment";
import { CreateMultiRoundTournamentComponent } from "./components/create-multi-round-tournament/create-multi-round-tournament.component";
import { UpdateMultiRoundTournamentComponent } from "./components/update-multi-round-tournament/update-multi-round-tournament.component";
import { MultiRoundComponent } from "./components/multi-round/multi-round.component";
import { MultiroundTournamentDetailComponentComponent } from "./components/multiround-tournament-detail-component/multiround-tournament-detail-component.component";
import { UserSelectModalComponentMultiRound } from "./directives/user-select-modal-multi-round";
import { CreatorDetailComponentComponent } from "./components/creator-detail-component/creator-detail-component.component";
import { CreatePrizeListComponent } from "./components/create-prize-list/create-prize-list.component";
import { TournamentManagerIndividualComponent } from './directives/tournament-manager-individual/tournament-manager-individual.component';
import { UserComponent } from './directives/user/user.component';
import { TournamentManagerTeamComponent } from './directives/tournament-manager-team/tournament-manager-team.component';
import { UserCardSquareComponent } from './directives/user-card-square/user-card-square.component';
import { UserSelectModalNewComponent } from './directives/user-select-modal-new/user-select-modal-new.component';
import { RaffleComponent } from "./components/raffle-component/raffle-component.component";
import { CreateRaffleComponent } from "./components/create-raffle/create-raffle.component";
import { UpdateRaffleComponent } from "./components/update-raffle/update-raffle.component";
import { RaffleDetailComponent } from "./components/raffle-detail/raffle-detail.component";
import { ExcelService } from "./services/excel.service";
import { RaffleOrderDetailComponent } from "./components/raffle-order-detail/raffle-order-detail.component";
import { UtilityService } from "./services/utility/utility.service";

firebase.initializeApp(environment.firebase);

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatTabsModule,
    MatCardModule,
    MatButtonModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    AngularFireModule.initializeApp(environment.firebase),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpModule,
    NgxEditorModule,
    ComponentsRoutingModule,
    BsDropdownModule.forRoot(),
    AccordionModule,
    ModalModule.forRoot(),
    CalendarModule,
    NgSelectModule,
    CheckboxModule,
    MatIconModule,
    MatAutocompleteModule,
    MatChipsModule,
    OrderModule,
    TabsModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatTabsModule,
    MatCardModule,
    MatRadioModule,
    NgDragDropModule.forRoot(),
    MatCheckboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatExpansionModule,
   NgxSummernoteModule,
    AmazingTimePickerModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyCTeop_aYmRMZCR67P-NKfvKlxoFyNt3z4",
      libraries: ["places"],
    }),
    ImageCropperModule,
  ],
  exports: [MatTabsModule, MatCardModule, MatButtonModule],
  declarations: [
    AppComponent,
    PaymentsListComponent,
    FullLayoutComponent,
    SimpleLayoutComponent,
    NAV_DROPDOWN_DIRECTIVES,
    TourComponent,
    TourProfileSubmenuComponent,
    PermissionAttribute,
    BreadcrumbsComponent,
    AdvertisementComponent,
    ClubMembersComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    AsideToggleDirective,
    ClubInsightComponent,
    FollowerRequestComponent,
    CompanyProfileComponent,
    ClubsComponent,
    EditPostComponent,
    TeeComponent,
    ZestMappingComponent,
    NotificationComponent,
    AddHolesComponent,
    TeeTimeBookingComponent,
    AdminCompanyInsightsComponent,
    ClubDetailComponent,
    PostReportComponent,
    FollowersComponent,
    ConfirmClubComponent,
    ClubSubscriptionsComponent,
    ClubSubscriptionDetailComponent,
    CompanyInsightComponent,
    UserReportComponent,
    UsersComponent,
    UserDetailComponent,
    ClubProfileComponent,
    PostsComponent,
    PendingPostsComponent,
    PostDetailComponent,
    PostEveryoneComponent,
    PermissionAttribute,
    CreatePostEveryoneComponent,
    TournamentsComponent,
    TournamentDetailComponent,
    UpdateTournamentComponent,
    AddTournamentNewComponent,
    OffersComponent,
    OrdersComponent,
    OfferDetailComponent,
    CourseComponent,
    AddLeagueComponent,
    LeaguesComponent,
    LeagueDetailComponent,
    UpdateLeagueComponent,
    UpdateOfferComponent,
    EntryNotificationComponent,
    ScorecardsComponent,
    InsightComponent,
    ClubScorecardsComponent,
    CompanyComponent,
    CompanyDetailComponent,
    OrderDetailComponent,
    PostInfoComponent,
    PostComponent,
    ChangePasswordComponent,
    AttachmentComponent,
    AttachmentWithoutCropComponent,
    PermissionComponent,
    AttachmentMultipleComponent,
    TextEditorComponent,
    TextEditorComponentComment,
    TournamentSelectComponent,
    DateTimePickerComponent,
    ClubSelectComponent,
    UserSelectModalComponent,
    UserSelectModalComponentMultiRound,
    CreatorDetailComponentComponent,
    CreatePrizeListComponent,
    TournamentPlayersComponent,
    CreateOfferComponent,
    TermConditionComponent,
    WebsiteTermConditionComponent,
    PrivatePolicyComponent,
    AppVersionComponent,
    BankComponent,
    AttachmentsComponent,
    MomentPipe,
    HandicapPipe,
    PostMsgPipe,
    GeneralPipe,
    TournamentPipe,
    OrderPipe,
    OfferPipe,
    UserPipe,
    VerifiedClubPipe,
    TeamFilterPipe,
    SafePipe,
    PrioritiesComponent,
    CommunityDashboardComponent,
    SocialDashboardComponent,
    PlayDashboardComponent,
    ProshopDashboardComponent,
    GeneralDashboardComponent,
    ClubProfileSubmenuComponent,
    CompanyProfileSubmenuComponent,
    InsightsManagerComponent,
    RoleManagerComponent,
    BirdietimeIntegrationComponent,
    HubberProIntegrationComponent,
    LiveScoringComponent,
    HubberPracticeComponent,
    SocietyComponent,
    SocietyProfileSubmenuComponent,
    PortfolioDashboardComponent,
    ProfileDashboardComponent,
    MyFollowersComponent,
    MyInsightsComponent,
    GhMobileAppComponent,
    ClubPackageComponent,
    TournamentsMatchplayDetailsComponent,
    TourInsightsComponent,
    SocietyInsightsComponent,
    TotalActiveComponiesComponent,
    AllPostsComponent,
    AppUsersComponent,
    AppUsersListComponent,
    EventsComponent,
    CreateEventComponent,
    EventDetailComponent,
    UpdateEventComponent,
    EffectiveTournamentsComponent,
    WebsiteEnquiriesComponent,
    CreateMultiRoundTournamentComponent,
    UpdateMultiRoundTournamentComponent,
    MultiRoundComponent,
    MultiroundTournamentDetailComponentComponent,
    TournamentManagerIndividualComponent,
    UserComponent,
    TournamentManagerTeamComponent,
    UserCardSquareComponent,
    UserSelectModalNewComponent,
    RaffleComponent,
    CreateRaffleComponent,
    UpdateRaffleComponent,
    RaffleDetailComponent,
    RaffleOrderDetailComponent
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    ApiService,
    AuthGuardService,
    RouteAuthGuardService,
    AdminRouteAuthGuardService,
    CanDeactivateGuard,
    ElasticService,
    FormsService,
    OAuthService,
    VersionCheckService,
    PagerService,
    PaymentsService,
    AngularFireAuth,
    AngularFireDatabase,
    ExcelService,
    UtilityService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
